import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import eventService from '../../services/EventService';
import vectorService from '../../services/VectorService';
import "../../static/css/slide.css";

export default function SlideActionEvent({show,onClose,onFetchEvents,search,event}) {
    const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        defaultValues: {
            vector: null,
            status: "true",
        },
    });
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [vectors, setVectors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const normalizeData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
            let value = data[key];

            if (typeof value === "string") {
                value = value.trim();
                if (key === "email") value = value.toLowerCase();
                else value = value.toUpperCase();
            }

            acc[key] = value;
            return acc;
        }, {});
    };

    const handleActionEvent= async (data) => {
        const normalizedData = normalizeData(data);
        if(!data?.id_event){
            eventService.add(normalizedData,reset)
                .then((res) => {
                    setMessage("Evento aggiunto con successo!");
                    setErrorMsg("");
                    onFetchEvents(search);
                    reset();
                }).catch((error) => {
                    console.error("Error add event: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiunta evento. Riprova.");
                }
            );
        } else {
            eventService.update(normalizedData,reset)
                .then((res) => {
                    setMessage("Evento modificato con successo!");
                    setErrorMsg("");
                    onFetchEvents(search);
                }).catch((error) => {
                    console.error("Error update event: ", error);
                    setMessage("");
                    setErrorMsg("Errore aggiornamento evento. Riprova.");
                }
            );
        }
    }

    const fetchVectors= async () => {
        try {
            const res = await vectorService.getAll();
            const resultsData = res.data || [];
            setVectors(resultsData);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching vectors', error);
        }
    };

    useEffect(() => {
        fetchVectors();
        reset(event);
    }, [event, reset]);

  	return (
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">{event.id_event ? "Modifica " : "Aggiungi "} Evento</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionEvent)}>
                    <div className="row">
                        <div className="col-9 mb-6">
                            <label className="form-label">Nome*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.name ? "is-invalid" : ""}`}>
                                    <i className="bx bx-store" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    {...register('name', { required: 'Nome richiesto' })}
                                />
                            </div>
                            {errors.name && <div className="invalid-input">{errors.name.message}</div>}
                        </div>
                        <div className="col-3 mb-6">
                            <label className="form-label">Anno*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.year ? "is-invalid" : ""}`}>
                                    <i className="bx bx-calendar-event" ></i>
                                </span>
                                <input type="number" className={`form-control ${errors.year ? "is-invalid" : ""}`}
                                    {...register('year', { required: 'Anno richiesto' })}
                                />
                            </div>
                            {errors.year && <div className="invalid-input">{errors.year.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Indirizzo</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.address ? "is-invalid" : ""}`}>
                                    <i className="bx bx-map" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                    {...register("address",
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.address && <div className="invalid-input">{errors.address.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Città</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.city ? "is-invalid" : ""}`}>
                                    <i className="bx bxs-city" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.city ? "is-invalid" : ""}`}
                                    {...register("city",
                                        {
                                            maxLength: {
                                                value: 200,
                                                message: "Limite massimo 200"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.city && <div className="invalid-input">{errors.city.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Inizio</label>
                            <input className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
                                type="date"
                                placeholder={`${errors.startDate ? errors.startDate.message : ""}`}
                                {...register("startDate")}
                             />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Fine</label>
                            <input className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
                                type="date"
                                placeholder={`${errors.endDate ? errors.endDate.message : ""}`}
                                {...register("endDate")}
                             />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mb-6">
                            <label className="form-label">Ricorrenza</label>
                            <select className={`form-select ${errors.recurrence ? "is-invalid" : ""}`}
                                type="text"
                                placeholder={`${errors.recurrence ? errors.recurrence.message : ""}`}
                                {...register('recurrence')}
                            >
                                <option value="">Seleziona</option>
                                <option value="0.6">2 volte anno</option>
                                <option value="1">1 volta ogni anno</option>
                                <option value="2">1 volta ogni 2 anni</option>
                                <option value="3">1 volta ogni 3 anni</option>
                                <option value="4">1 volta ogni 4 anni</option>
                                <option value="5">1 volta ogni 5 anni</option>
                            </select>
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Vettore</label>
                                <Controller
                                name="vector"
                                control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isClearable
                                            placeholder="Seleziona un vettore"
                                            classNamePrefix='filter'
                                            options={vectors}
                                            getOptionLabel={(e) => e.name}
                                            getOptionValue={(e) => e.id_vector}
                                        />
                                    )}
                                />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Email</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.email ? "is-invalid" : ""}`}>
                                    <i className="bx bx-envelope" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                    {...register("email", {
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Email non valida!"
                                        }
                                    })}
                                />
                            </div>
                            {errors.email && <div className="invalid-input">{errors.email.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Telefono</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.phone ? "is-invalid" : ""}`}>
                                    <i className="bx bx-phone" ></i>
                                </span>
                                <input type="text" className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                    {...register("phone",
                                        {
                                            maxLength: {
                                                value: 25,
                                                message: "Limite massimo 25"
                                            }
                                        }
                                    )}
                                />
                            </div>
                            {errors.phone && <div className="invalid-input">{errors.phone.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Stato</label>
                            <select className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('status', { required: 'Seleziona uno stato' })}
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                            {errors.status && <div className="invalid-input">{errors.status.message}</div>}
                        </div>
                    </div>
                    <div className="col mb-6">
                        <label className="form-label">Orari e Note</label>
                        <textarea className="form-control" placeholder="Descrizione..."
                            {...register("note")}
                         />
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                    {!event.id_event && <button type="reset" className="btn btn-label-danger">Cancella</button>}
                </form>
            </div>
        </div>
	);
}